(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-clearance-families"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    // Covers regimes 2 AND 3 now, plus regime 1's own narrow edge (Aug 2026
    // fourth rebuild) -- everything below the width where 3-column cards
    // actually clear with full-format content, not just true phone widths
    // or the raw column-count crossover. Named for what it gates (the short
    // date format), not for a device class or a grid breakpoint it no
    // longer maps 1:1 to. 1349px: live-bisected against full-format
    // content specifically (not the column count) -- 1280px still clips
    // (1.5px), 1285px clears but at a razor-thin -0.2px margin, 1290px is
    // the first genuinely clean point (-1.8px). 1349px keeps real headroom
    // past that edge (390px cards, -21.8px margin at the boundary itself),
    // same margin philosophy as every other threshold here -- applying the
    // short format a bit further into regime 1's own territory than
    // strictly required is a cosmetic non-issue; landing short of a real
    // clean margin is the clipping bug this rebuild exists to close, twice
    // over now.
    const compactQuery = window.matchMedia('(max-width: 1349px)');
    // Matches exactly what delivery-badges.js's dateDisplay() renders in
    // "short" mode for a family row: "Arrives {Mon..Sun}, {Jan..Dec} {day}".
    // Anything else (a "long"-format date, a copy change, a null result)
    // fails this match on purpose and is left untouched.
    const WEEKDAY_PATTERN =
      /^Arrives (?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), ([A-Z][a-z]{2} \d{1,2})$/;

    // "Arrives Weekday, Month Day" -> "Est. Month Day" (Aug 2026, row-fit
    // fix, widened from phone-only to every width compactQuery matches).
    // The literal "Arrives Weekday" prefix is discarded rather than reused
    // (never captured by the regex above -- nothing needs it). "Est." was
    // chosen over a literal date-only string to echo the PDP's own
    // "Estimated delivery" language, and specifically over "By" -- "By"
    // reads as a guaranteed upper bound; the app returns an estimate, not a
    // guarantee. Only the wide end of regime 1 (>=1350px) is untouched now
    // -- callers only ever invoke this inside the compactQuery gate. Called
    // from two places: revealPlaceholders() below, on a still-placeholder
    // element that's about to be revealed (Aug 2026 load-sequence fix --
    // strips before the element is ever visible, see that function's own
    // comment), and scan(), for an already-revealed element that needs
    // stripping after the viewport crosses the compactQuery boundary
    // post-load. Idempotent either way -- already-stripped text doesn't
    // match WEEKDAY_PATTERN, so a second call is always a safe no-op.
    function stripWeekday(el) {
      const match = el.textContent.match(WEEKDAY_PATTERN);
      if (!match) return;
      el.dataset.weekdayStripped = 'true';
      el.textContent = `Est. ${match[1]}`;
    }

    function revealPlaceholders() {
      document
        .querySelectorAll('[data-family-row-delivery-slot][data-placeholder]')
        .forEach((el) => {
          // el.dataset.placeholderValue is the fixed concatenation of both
          // placeholder spans' text (Liquid-stamped, see family-card.liquid's
          // markup) -- constant regardless of which span CSS currently
          // shows, since textContent reads DOM text nodes, not computed
          // visibility. The app is the only thing that ever changes a
          // placeholder-flagged element's children, so any mismatch here
          // means real data landed.
          if (el.textContent === el.dataset.placeholderValue) return;

          // Strip BEFORE revealing, not after (Aug 2026 load-sequence fix).
          // Previously this function only removed data-placeholder, and
          // scan() -- called immediately afterward inside scanAll(), see
          // below -- did the compact-width stripping on the same pass. That
          // happened to be safe under normal JS engine behavior: both calls
          // run synchronously in one task, so the browser has no
          // opportunity to paint the element between "now visible" and "now
          // stripped" -- they land in the same frame. But that safety
          // depended on the two functions always being called back-to-back
          // with nothing in between, an implicit ordering property of
          // scanAll(), not a guarantee this function makes on its own. A
          // real user reported seeing the unstripped "Arrives Weekday,
          // Month Day" text render before the "Est. Month Day" rewrite --
          // reproduced in a controlled, race-free single-write test with
          // this project's own instrumentation, the same-tick coupling held
          // (no visible intermediate state), so the exact trigger for what
          // was seen live wasn't pinned down. Rather than leave the fix
          // resting on "should be atomic," stripping is now a precondition
          // of revealing: at compact widths, the element's text is already
          // correct BEFORE visibility ever changes, so showing unstripped
          // content is structurally impossible, not just unlikely.
          if (compactQuery.matches) {
            stripWeekday(el);
          }
          delete el.dataset.placeholder;
        });
    }

    // Post-reveal stripping only now (Aug 2026 load-sequence fix moved
    // first-reveal stripping into revealPlaceholders() itself, above) --
    // this only ever runs against an element that's already visible, no
    // longer against one in the same tick it's revealed. Still needed for
    // exactly one case: an element revealed while compactQuery didn't match
    // (full format, correctly left alone at reveal time) whose viewport
    // later crosses down below 1349px -- the :not([data-placeholder]) guard
    // means this and revealPlaceholders() always operate on disjoint
    // elements, so call order between them in scanAll() no longer matters.
    //
    // No :not([data-weekday-stripped]) guard on the selector (Aug 2026,
    // column-width audit -- a real bug, not the width bug itself, found in
    // the same pass): that guard made re-stripping structurally impossible
    // once set, verified live by writing a fresh long string into an
    // already-stripped element and watching it stay long and visible
    // indefinitely. Today, every product ID is written exactly once
    // (confirmed via delivery-badges.js's own source -- see the top-of-file
    // comment), so no single element is ever re-written in practice -- but
    // that's an assumption about a third-party script's current behavior,
    // not a guarantee, and the guard's only real job (skip re-processing an
    // element that's already correctly short) is already handled by
    // stripWeekday()'s own regex check, which is naturally idempotent --
    // calling it again on already-short text is a safe no-op. The extra
    // guard bought nothing but a latent trap. data-weekday-stripped is
    // still set by stripWeekday() itself, for inspection/debugging -- it
    // just no longer gates anything here.
    function scan() {
      if (!compactQuery.matches) return;
      document
        .querySelectorAll('[data-family-row-delivery-slot]:not([data-placeholder])')
        .forEach((el) => {
          if (el.textContent.trim() !== '') stripWeekday(el);
        });
    }

    function scanAll() {
      revealPlaceholders();
      scan();
    }

    // Scoped to the grid, not document.body (Aug 2026, column-width audit --
    // a real bug, not the width bug itself, found in the same pass): a
    // document.body-wide observer reacts to every mutation ANYWHERE on the
    // page, including constant third-party churn (GTM, Judge.me, Omnisend,
    // Richpanel and friends all mutate the DOM outside this grid, routinely,
    // for their own reasons). Every one of those unrelated mutations reset
    // scheduleScan's debounce timer, so the "100ms" debounce was measured
    // live to behave as ~1.1s in practice -- not a rare fluke, the normal
    // case. .collection-wrapper (this section's own top-level container,
    // rendered above) only ever mutates from this grid's own content --
    // scoping to it removes the noisy retrigger source directly, rather
    // than fighting it with a shorter timer that third-party churn would
    // just keep resetting too.
    let scanTimer = null;
    function scheduleScan() {
      clearTimeout(scanTimer);
      scanTimer = setTimeout(scanAll, 100);
    }

    scanAll();
    const grid = document.querySelector('.collection-wrapper') || document.body;
    new MutationObserver(scheduleScan).observe(grid, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    // Handles a viewport crossing the compactQuery boundary after load
    // (resize, or a real 4th-column-eligible ultra-wide window shrinking
    // back down); scan() is naturally idempotent now (see its own comment
    // above), so this is safe to call repeatedly regardless. revealPlaceholders()
    // has no breakpoint gate of its own -- regime 1 placeholders need
    // revealing too -- so this uses scanAll(), not scan(), even though only
    // the weekday-strip half cares about this specific event.
    compactQuery.addEventListener('change', scanAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-replace-products"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-autoplay"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE = '(max-width: 749px)';
    const REDUCED = '(prefers-reduced-motion: reduce)';

    function init(frame) {
      if (frame.dataset.kocVideoReady === '1') return;
      frame.dataset.kocVideoReady = '1';

      const video = frame.querySelector('.koc-video__el');
      const toggle = frame.querySelector('.koc-video__toggle');
      if (!video || !toggle) return;

      const wantsAutoplay = frame.dataset.autoplay === 'true';
      const prefersReduced = window.matchMedia(REDUCED).matches;
      const mobileQuery = window.matchMedia(MOBILE);

      // A manual pause must stick: scrolling away and back should not
      // restart a video the viewer deliberately stopped.
      let userPaused = false;

      function chosenSource() {
        const mobile = video.dataset.srcMobile;
        const desktop = video.dataset.srcDesktop;
        return mobileQuery.matches ? mobile || desktop : desktop || mobile;
      }

      function ensureLoaded() {
        const src = chosenSource();
        if (!src || video.getAttribute('src') === src) return;
        video.setAttribute('src', src);
        video.load();
      }

      function setState(playing) {
        frame.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-pressed', String(playing));
        const label = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
        if (label) toggle.setAttribute('aria-label', label);
      }

      function play() {
        ensureLoaded();
        const attempt = video.play();
        // Playback can still be refused (iOS low power mode, for one).
        // Fall back to the paused state rather than lying in the UI.
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => setState(false));
        }
      }

      video.addEventListener('playing', () => {
        frame.classList.add('has-started');
        setState(true);
      });
      video.addEventListener('pause', () => setState(false));

      toggle.addEventListener('click', () => {
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      });

      if (!('IntersectionObserver' in window)) {
        if (wantsAutoplay && !prefersReduced) play();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (wantsAutoplay && !prefersReduced && !userPaused) play();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(frame);

      // Crossing the breakpoint after a source is already assigned should
      // swap to the right file rather than keep serving the other one.
      function onBreakpointChange() {
        if (!video.getAttribute('src')) return;
        const next = chosenSource();
        if (!next || video.getAttribute('src') === next) return;
        const wasPlaying = !video.paused;
        video.setAttribute('src', next);
        video.load();
        if (wasPlaying) play();
      }

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', onBreakpointChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(onBreakpointChange);
      }
    }

    function boot() {
      document.querySelectorAll('[data-koc-video]').forEach(init);
    }

    boot();
    document.addEventListener('DOMContentLoaded', boot);
    // Re-init when the theme editor swaps this section in.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
